// extracted by mini-css-extract-plugin
export default {"spin":"loading_spin__X9Z3Q"};